import { render, staticRenderFns } from "./teldetyhpj.vue?vue&type=template&id=972e403c&scoped=true&"
import script from "./teldetyhpj.vue?vue&type=script&lang=js&"
export * from "./teldetyhpj.vue?vue&type=script&lang=js&"
import style0 from "./teldetyhpj.vue?vue&type=style&index=0&id=972e403c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972e403c",
  null
  
)

export default component.exports